import React from "react";
import css from './center.module.scss'
import {observer} from "mobx-react";
import classNames from "classnames";

const Index = ({className, children}) => {
    return (
        <div id='center' className={classNames(className, css.root)}>
            {children}
        </div>
    )
}

export default observer(Index)